import { Link } from "react-router-dom";
import { videos } from "@/mocks/videos";
import type { Video } from "@/types/video";
import { getFeatured, getHotRanking, getLatest } from "@/utils/video";
import VideoCard from "@/components/base/VideoCard";
import HeroCarousel from "./components/HeroCarousel";
import CategoryEntry from "./components/CategoryEntry";
import HotRanking from "./components/HotRanking";

export default function Home() {
  const list = videos as Video[];
  const featured = getFeatured(list);
  const latest = getLatest(list, 12);
  const hot = getHotRanking(list, 10);

  return (
    <div className="w-full">
      <HeroCarousel items={featured} />

      <CategoryEntry />

      <section className="mx-auto max-w-[1280px] px-4 pb-14 md:px-8">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_320px]">
          <div>
            <div className="mb-6 flex items-end justify-between">
              <div>
                <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                  最新影视推荐
                </h2>
                <p className="mt-1 text-sm text-foreground-600">
                  最近更新的热门影片，第一时间不错过好内容
                </p>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
              {latest.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>

          <div className="w-full">
            <HotRanking items={hot} />
          </div>
        </div>
      </section>

      <section className="border-t border-background-200/60 bg-background-100">
        <div className="mx-auto flex max-w-[1280px] flex-col items-start gap-5 px-4 py-12 md:flex-row md:items-center md:justify-between md:px-8">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950">
              想看什么，一搜就有
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">
              覆盖电影、电视剧、综艺全频道，支持标题、类型、地区、演员多维搜索，快速定位你想看的影片。
            </p>
          </div>
          <Link
            to="/search"
            className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-search-line text-lg"></i>
            立即搜索影视
          </Link>
        </div>
      </section>
    </div>
  );
}